module.exports = __webpack_public_path__ + "img/logo_symbol_only.67e4d471.png";